module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/X-Ray设备.9fb9c44c.png";